import { render, staticRenderFns } from "./studyway.vue?vue&type=template&id=6cdc1f9c&scoped=true"
import script from "./studyway.vue?vue&type=script&lang=js"
export * from "./studyway.vue?vue&type=script&lang=js"
import style0 from "./studyway.vue?vue&type=style&index=0&id=6cdc1f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc1f9c",
  null
  
)

export default component.exports